<freud-alert-message
	*ngIf="shouldShowNoPromptuaryAlert()"
	severity="warn"
	[text]="'APPOINTMENTS.DETAILS.BODY.ALERT.NO_PROMPTUARY' | translate"
>
</freud-alert-message>